import { SvgIcon, SvgIconProps } from '@mui/material'

const UploadImage = (props: SvgIconProps) => {
  return (
    <SvgIcon role="img" viewBox="0 0 16 16" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13 6.5C13.2761 6.5 13.5 6.72386 13.5 7V13C13.5 13.2761 13.2761 13.5 13 13.5H1C0.723858 13.5 0.5 13.2761 0.5 13V7.00277C0.5 6.72662 0.723858 6.50277 1 6.50277C1.27614 6.50277 1.5 6.72662 1.5 7.00277V12.5H12.5V7C12.5 6.72386 12.7239 6.5 13 6.5Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.64645 0.646447C6.84171 0.451184 7.15829 0.451184 7.35355 0.646447L10.3536 3.64645C10.5488 3.84171 10.5488 4.15829 10.3536 4.35355C10.1583 4.54882 9.84171 4.54882 9.64645 4.35355L7 1.70711L4.35355 4.35355C4.15829 4.54882 3.84171 4.54882 3.64645 4.35355C3.45118 4.15829 3.45118 3.84171 3.64645 3.64645L6.64645 0.646447Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.99731 0.5C7.27346 0.5 7.49731 0.723858 7.49731 1V9.66667C7.49731 9.94281 7.27346 10.1667 6.99731 10.1667C6.72117 10.1667 6.49731 9.94281 6.49731 9.66667V1C6.49731 0.723858 6.72117 0.5 6.99731 0.5Z"
        fill="currentColor"
      />
    </SvgIcon>
  )
}

export default UploadImage
